import { usePayPeriods } from 'core/hooks/data/useDataHook'
import { useMemo } from 'react'
import { PayPeriod } from 'types/pay-periods'
import { getPayPeriodsTotal } from 'utils/Functions'

const useIndexedPayPeriods = () => {
  const { data, ...rest } = usePayPeriods({
    params: {
      status: 'active',
      page: 1,
      pageSize: 100
    }
  })

  const payPeriods = useMemo(() => data?.data ?? [], [data?.data])

  const indexedPayPeriods = useMemo(() => {
    const _indexedPayPeriods: Record<string, PayPeriod> = {}

    payPeriods.forEach((payPeriod) => {
      _indexedPayPeriods[payPeriod.id] = payPeriod
    })

    return _indexedPayPeriods
  }, [payPeriods])

  const allPayPeriodsTotal = useMemo(
    () => getPayPeriodsTotal(payPeriods),
    [payPeriods]
  )

  return {
    payPeriods,
    indexedPayPeriods,
    allPayPeriodsTotal,
    ...rest
  }
}

export default useIndexedPayPeriods
